<div class="toast-container" *ngIf="toasterService.showToaster$ | async">
  <img src="assets/img/check-circle-green.svg" height="24" width="24" alt="">
  {{message | translate}}
</div>
